export default class RegExpOptions {
    constructor(init) {
        this.caseSensitive = true;
        this.global = false;
        Object.assign(this, init);
    }
    toFlags() {
        return ''
            .concat(this.global ? 'g' : '')
            .concat(!this.caseSensitive ? 'i' : '');
    }
}
//# sourceMappingURL=RegExpOptions.js.map